module.exports = __webpack_public_path__ + "static/inova-353aa44ac38e29c2140f99ff0521748c.png";